// Runs from `app.js` BEFORE the Redux store, router, or React tree are built,
// so `api.basename` and the SSO/deployment config are ready for the very first
// API and OIDC-discovery call. `AppSettingsGetter`'s in-tree `useEffect` was
// too late — react-router's `onEnter` fires `loadCurrentUser()` and the SSO
// provider reads `ssoApiBaseUrl` at first render, both ahead of the effect,
// which is why those requests kept landing on the CDN origin.
//
// Failures are logged and swallowed. Missing `/settings.json` is a valid state
// in dev (rspack config serves a stub) and, at worst, in prod means the SPA
// falls through to same-origin — same behavior as before this hook existed.

import { setBasename } from "metabase/utils/basename";

import { type AppSettings, setConfigSettings } from "./configs";

export const preRenderBootstrap = async (): Promise<void> => {
  try {
    const response = await fetch("/settings.json");
    if (!response.ok) {
      return;
    }
    const settings: AppSettings = await response.json();
    setConfigSettings(settings);
    setBasename(settings.insightsApiBaseUrl);
  } catch (err) {
    console.error("preRenderBootstrap: failed to load /settings.json", err);
  }
};
